<template>
  <div>
    <section id="contact">
      <div class="container">
        <h1 class="bigTitle has-text-centered">Let's talk.</h1>
        <div class="columns">
          <div class="column is-one-half">
            <div class="form-contain">
              <p>Shoot us an email:</p> <br>
              <client-only placeholder="Loading...">
                <script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/shell.js" />
                <script>
                  hbspt.forms.create({
                  portalId: "702696",
                  formId: "7e123527-1a38-4d12-aa93-96f8872b6746"
                  });
                </script>
              </client-only>
            </div>
          </div>
          <div class="column is-one-half more-contact">
            <div>
              <p>
                We love talking about cartonization! Use the form to send us an email, or chat with us using the chat button located at the bottom right of every page.
              </p>
              <p>
                <strong>Chat Hours</strong><br>
                Monday-Friday 9AM-5PM, EST
              </p>
              </p>
              <p>
                Looking for a testing key so you can try out Paccurate? You can now <a href="https://manage.paccurate.io/sign_up">sign up for a free trial</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <recent-news :posts="posts" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import RecentNews from '~/components/RecentNews.vue'

export default {
  components: {
    RecentNews
  },
  head () {
    return {
      title: "Let's talk"
    }
  },
  computed: {
    ...mapState([
      'posts'
    ])
  }
}
</script>

<style scoped>
  p{
    margin-bottom: 1em;
  }
  #contact{
    padding: 4em 0em;
    padding-bottom: 8em;
  }
  h2.bigTitle{
    font-size: 3em;
    margin-bottom: 2em;
  }
  .form-contain{
    padding: 2em;
    border: 1px solid #ddd;
    background: #ececec;
  }
  .more-contact div{
      padding: 1em 15%;
  }
  .hbspt-form .hs-form-iframe {
    width: 100% !important;
  }
</style>
